import { render, staticRenderFns } from "./image_viewer.vue?vue&type=template&id=6c6110a6&scoped=true&"
import script from "./image_viewer.vue?vue&type=script&lang=js&"
export * from "./image_viewer.vue?vue&type=script&lang=js&"
import style0 from "./image_viewer.vue?vue&type=style&index=0&id=6c6110a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6110a6",
  null
  
)

export default component.exports